/**
 * PDP gallery: native overflow-x on mobile, Swiper + thumbs on desktop.
 */
import { Swiper, Thumbs } from '../vendor/swiper.js';
import {
  bindNativePdpGallery,
  createInitDetailGallery,
  isPdpMobile,
  prepareMainGallery,
  resetMobileVideo,
} from './detail-gallery-core.js';

function initMainGallery(root, thumbsSwiper) {
  const container = root.querySelector('.item_slider.flex');
  const wrapper = prepareMainGallery(container);

  if (!container || !wrapper || wrapper.children.length === 0) {
    return null;
  }

  if (isPdpMobile()) {
    bindNativePdpGallery(container, wrapper, root);
    return null;
  }

  const swiper = new Swiper(container, {
    modules: [Thumbs],

    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500,
    loop: false,
    watchOverflow: true,
    initialSlide: 0,
    observer: false,
    observeParents: false,
    direction: 'horizontal',
    simulateTouch: true,
    followFinger: true,
    touchRatio: 1,
    grabCursor: true,
    threshold: 0,
    resistanceRatio: 0.7,
    longSwipes: true,
    shortSwipes: true,
    thumbs: thumbsSwiper
      ? {
        swiper: thumbsSwiper,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        multipleActiveThumbs: false,
      }
      : undefined,
  });

  if (swiper.activeIndex !== 0) {
    swiper.slideTo(0, 0, false);
  }

  swiper.on('slideChange', () => {
    resetMobileVideo(root);
  });

  return swiper;
}

export const initDetailGallery = createInitDetailGallery(initMainGallery);
